import React from "react";

function AssessmentSummaryTitle({children}){
    return (<React.Fragment>
        <h2 style={{width:"100%"}}>{children}</h2>
        <hr style={{marginBottom:"20px"}} />
    </React.Fragment>);
}

export default AssessmentSummaryTitle;